import { useEffect } from "react";
import * as amplitude from "@amplitude/analytics-browser";
import {
  SHARED_EVENTS_PARAMS
} from "@app/dashboard/constants/tracking_events/shared";
import {
  TEST_LIVE_MODE_EVENTS
} from "@app/dashboard/constants/tracking_events/test-live-modes";
import type { IInfoBar } from "@app/dashboard/types/innerLayout/info-bar";
import { getCurrentPath } from "@app/dashboard/utils/getCurrentPath";
import styles from "./info-bar.module.scss";

export const InfoBar = (
  {
    status = 'default',
    text,
    usedFor
  }
    : IInfoBar
) => {

  useEffect(() => {
    const isTestModeBannerVisible = usedFor === 'test_mode' && text;

    isTestModeBannerVisible &&
      amplitude.track(TEST_LIVE_MODE_EVENTS.BANNER_VEIWED, {
        [SHARED_EVENTS_PARAMS.PAGE]: getCurrentPath()
      });

  }, [usedFor, text]);

  return (
    text
    &&
    <div className={styles["info-bar"]} data-info-bar={status}>
      {text}
    </div>
  )
};